import "./ServicesStyles.css"
import IMG_00 from '../Assets/IMG-04.jpg';
import IMG_01 from '../Assets/IMG-05.jpg';
import IMG_02 from '../Assets/IMG-21.jpg';
import IMG_03 from '../Assets/IMG-07.jpg';
import IMG_04 from '../Assets/IMG-14.jpg';
import IMG_05 from '../Assets/IMG-15.jpg';
import IMG_06 from '../Assets/IMG-18.jpg';
import IMG_07 from '../Assets/IMG-02.jpg';
import ServicesData from "./ServicesData";

const ServicesOffered = () =>{
    return(
        <div className="destinations">
            <h1>Elevate wellness Services</h1>
            <p>Your mental health is our priority</p>
            
           <ServicesData
           className="first-des"
           
           heading = "Family Counseling and Therapy"
           text="Family Counseling and Therapy at Elevate Wellness offers comprehensive support for individuals and families navigating life’s challenges. Our services include individual and family therapy sessions tailored to unique needs, as well as specialized counseling for children and teens. We provide conflict resolution and communication workshops to foster healthier relationships and understanding within families. Our experienced therapists also guide clients through trauma, loss, and grief, ensuring compassionate care during difficult times. Additionally, we offer pre-marital counseling to help couples build strong foundations for their future together, promoting resilience and emotional well-being for all family members."

           img1={IMG_00}
           img2={IMG_01}

           
           />

        <ServicesData
        className="first-des-reverse"

           
           heading = "Mental Health Services"
           text="Our Mental Health Services provide comprehensive assessments and personalized care for a wide range of needs. We offer alcohol and substance use counseling, psychological first aid, and crisis intervention support to help individuals in urgent situations. Our team utilizes evidence-based treatments for trauma, loss, anxiety, depression, and more, ensuring effective and compassionate care. We also extend Employee Wellness services to companies and religious organizations, promoting mental well-being in the workplace and faith communities. Through our holistic approach, we strive to empower individuals to overcome challenges and achieve lasting mental health and resilience."

           img1={IMG_03}
           img2={IMG_02}

           
           />
           <br></br>
           <br></br>
           <ServicesData
           
           className="first-des"
           
           heading = "Training and Workshops"
           text="Our Training and Workshops are designed to equip individuals and groups with essential life skills. We offer parenting skills training, coping and stress management workshops tailored for religious leaders, companies, and more. Our programs include team building and change management sessions to foster adaptability and collaboration. Relationship-building and effective communication workshops help participants strengthen connections and resolve conflicts. Each session is interactive and practical, providing tools that can be applied in daily life and professional settings. Our goal is to empower participants to thrive in their personal, family, and organizational roles."

           img1={IMG_04}
           img2={IMG_05}

           
           />

        <ServicesData
        className="first-des-reverse"

           
           heading = "Community Support Services"
           text="Community Support Services at Elevate Wellness foster connection and resilience through a variety of programs. We facilitate support groups for single parents, couples, and teens, providing safe spaces for sharing and growth. Our resources assist families navigating life transitions such as divorce or grief, offering guidance and encouragement. We also deliver mental health education programs for schools and community organizations, raising awareness and reducing stigma. By building supportive networks and providing accessible information, we help individuals and families face challenges with confidence and hope."

           img1={IMG_06}
           img2={IMG_07}

           
           />
        </div>
    );
};

export default ServicesOffered;